/* eslint-disable no-unused-vars */
import { makeRequest } from '../Axios';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from 'js-cookie'; //this is required for NCEP

//Dummy geoJson Data
const geoJson = [
  {
    type: 'Feature',
    properties: {
      fillColor: 'green',
      opacity: 1,
      color: 'black', //Outline color
      fillOpacity: 0.6
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [74.320503, 31.481449],
          [74.322241, 31.483018],

          [74.321136, 31.480762],
          [74.320627, 31.48122],
          [74.320503, 31.481449]
        ]
      ]
    }
  },
  {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [74.320503, 31.481449],
          [74.322241, 31.483018],
          [74.323324, 31.482876],
          [74.324032, 31.481751],
          [74.32259, 31.480021],
          [74.321136, 31.480762],
          [74.320627, 31.48122],
          [74.320503, 31.481449]
        ]
      ]
    }
  },
  {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Point',
      coordinates: [74.3301, 31.4775]
    }
  },
  {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [
            [74.320503, 31.481449],
            [74.322241, 31.483018],
            [74.323324, 31.482876],
            [74.324032, 31.481751],

            [74.320503, 31.481449]
          ]
        ]
      ]
    }
  },
  {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [74.320906, 31.483416],
          [74.324832, 31.483311],
          [74.32495, 31.482711],
          [74.324687, 31.482263],
          [74.324531, 31.481636],
          [74.320954, 31.482597],
          [74.320906, 31.483416]
        ]
      ]
    }
  },
  {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [-71.33, 46.566],
              [-70.33, 46.566],
              [-70.33, 47.566],
              [-71.33, 47.566],
              [-71.33, 46.566]
            ]
          ]
        }
      },
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [-71.33, 46.566],
              [-70.33, 46.566],
              [-70.33, 47.566],
              [-71.33, 47.566],
              [-71.33, 46.566]
            ]
          ]
        }
      }
    ]
  }
];

const AR_BASE_URL = process.env.REACT_APP_ASSET_REGISTRY_BASE_URL || '';
const TERAPIPE_BASE_URL = process.env.REACT_APP_SERVER_URL || '';
const SERVER_URL = process.env.REACT_APP_SERVER_URL || '';

const MapService = {
  getField: async (unique_id) => {
    try {
      const response = await makeRequest(SERVER_URL + `/fetch-field/${unique_id}`, 'GET', {
        'Access-Control-Allow-Origin': '*'
      });
      localStorage.setItem('field_name', response.data['field_name']);
      console.log(localStorage.getItem('field_name'));
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message, { position: toast.POSITION.TOP_RIGHT });
      throw error?.response?.data;
    }
  },
  getCoordinates: async (scope) => {
    try {
      const response = await makeRequest(
        SERVER_URL + `/get-coordinates`,
        'POST',
        {
          'Access-Control-Allow-Origin': '*'
        },
        { scope }
      );
      return response;
    } catch (error) {
      toast.error(error?.response?.data?.message, { position: toast.POSITION.TOP_RIGHT });
      throw error?.response?.data;
    }
  },
  setName: async (unique_id, name) => {
    try {
      const response = await makeRequest(
        SERVER_URL + `/set-name/${unique_id}`,
        'POST',
        {
          'Access-Control-Allow-Origin': '*'
        },
        { name }
      );
      return response;
    } catch (error) {
      throw error?.response;
    }
  },
  deleteField: async (unique_id) => {
    try {
      const response = await makeRequest(SERVER_URL + `/delete-field/${unique_id}`, 'DELETE', {
        'Access-Control-Allow-Origin': '*'
      });
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message, { position: toast.POSITION.TOP_RIGHT });
      throw error?.response?.data;
    }
  },
saveField: async (geoId) => {
  try {
    const response = await makeRequest(
      TERAPIPE_BASE_URL + `/geo-id`,
      'POST',
      {
        'Access-Control-Allow-Origin': '*'
      },
      { geo_id: geoId }
    );

    return response;
  } catch (error) {
    if (error?.response?.data?.message === 'Add Geo Id Error :::') {
      toast.error('Field already added', { position: toast.POSITION.TOP_RIGHT });
      console.log('ERROR ::: ', error);
    }
    // Optionally rethrow or handle other errors
    // throw error?.response?.data;
  }
}
,
  subscribeScope: async (scope_name, coords) => {
    try {
      const response = await makeRequest(
        TERAPIPE_BASE_URL + `/add_user_scope`,
        'POST',
        {
          'Access-Control-Allow-Origin': '*'
        },
        { scope_name: scope_name, coordinates: coords }
      );
      return response;
    } catch (error) {
      toast.error(`${error?.response?.data?.error}`, { position: toast.POSITION.TOP_RIGHT });
      console.log('ERROR ::: ', error);
    }
  },
  unsubscribeScope: async (scope_name) => {
    try {
      const response = await makeRequest(
        TERAPIPE_BASE_URL + `/remove_scope`,
        'POST',
        {
          'Access-Control-Allow-Origin': '*'
        },
        { scope_name: scope_name }
      );
      return response;
    } catch (error) {
      toast.error(`${error?.response?.data?.error}`, { position: toast.POSITION.TOP_RIGHT });
      console.log('ERROR ::: ', error);
    }
  },
  requestActivation: async (scope_name, coords) => {
    try {
      const response = await makeRequest(
        TERAPIPE_BASE_URL + `/request-activation`,
        'POST',
        {
          'Access-Control-Allow-Origin': '*'
        },
        { scope: scope_name, coordinates: coords }
      );
      return response;
    } catch (error) {
      toast.error(`${error?.response?.data?.error}`, { position: toast.POSITION.TOP_RIGHT });
      console.log('ERROR ::: ', error);
    }
  },
  getScopeStatus: async () => {
    try {
      const response = await makeRequest(TERAPIPE_BASE_URL + `/get_user_scope`, 'GET', {
        'Access-Control-Allow-Origin': '*'
      });
      return response.data;
    } catch (error) {
      toast.error(`${error?.response?.data?.error}`, { position: toast.POSITION.TOP_RIGHT });
      console.log('ERROR ::: ', error);
    }
  },
  plotData: async (geoId) => {
    try {
      const response = await makeRequest(TERAPIPE_BASE_URL + `/getWeatherForecast?geoid=${geoId}`, 'GET', {
        'Access-Control-Allow-Origin': '*'
      });
      return response.data['JSON Response'];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  soilData: async (geoId) => {
    try {
      const response = await makeRequest(TERAPIPE_BASE_URL + `/getSoil?geoid=${geoId}`, 'GET', {
        'Access-Control-Allow-Origin': '*'
      });
      return response.data['JSON Response'];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  tmfData: async (geoId) => {
    try {
      const response = await makeRequest(TERAPIPE_BASE_URL + `/getTMF?geoid=${geoId}`, 'GET', {
        'Access-Control-Allow-Origin': '*'
      });
      return response.data;
    } catch (error) {
      throw error?.response?.data;
    }
  },
  NDVIData: async (geoId, startDate, endDate) => {
    try {
      const response = await makeRequest(
        TERAPIPE_BASE_URL + `/getNDVIStats?geoid=${geoId}&start_date=${startDate}&end_date=${endDate}`,
        'GET',
        {
          'Access-Control-Allow-Origin': '*'
        }
      );
      return response.data['JSON Response'];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  // NCEPData: async (geoId, startDate, endDate) => {
  //   try {
  //     let base_url =
  //       TERAPIPE_BASE_URL +
  //       `/getNCEPStats?geoid=${geoId}&start_date=${startDate}`;
  //     if (endDate) {
  //       base_url += `&end_date=${endDate}`;
  //     }
  //     const response = await makeRequest(base_url, "GET", {
  //       "Access-Control-Allow-Origin": "*",
  //     });
  //     return response.data["JSON Response"];
  //   } catch (error) {
  //     throw error?.response?.data;
  //   }
  // },

  NCEPData: async (geoId, startDate, endDate) => {
    try {
      let base_url =
        TERAPIPE_BASE_URL +
        `/getNCEPStats?geoid=${geoId}&start_date=${startDate}`;
      if (endDate) {
        base_url += `&end_date=${endDate}`;
      }

      const token = Cookies.get('access_token');

      const response = await fetch(base_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": token ? `Bearer ${token}` : "", 
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API Error: ${response.status} - ${errorText}`);
      }

      const textData = await response.text();
      const sanitizedText = textData.replace(/:\s*NaN/g, ": null");
      const parsedData = JSON.parse(sanitizedText);
      return parsedData["JSON Response"];

    } catch (error) {
      console.error("NCEP Data Parse Error:", error);
      throw error;
    }
  },
  
  NLDASData: async (geoId, startDate, endDate) => {
    try {
      let base_url =
        TERAPIPE_BASE_URL +
        `/getNLDASStats?geoid=${geoId}&start_date=${startDate}`;
      if (endDate) {
        base_url += `&end_date=${endDate}`;
      }
      const response = await makeRequest(base_url, "GET", {
        "Access-Control-Allow-Origin": "*",
      });
      return response.data["JSON Response"];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  NOAAData: async (geoId, startDate, endDate) => {
    try {
      let base_url =
        TERAPIPE_BASE_URL +
        `/getNOAAStats?geoid=${geoId}&start_date=${startDate}`;
      if (endDate) {
        base_url += `&end_date=${endDate}`;
      }
      const response = await makeRequest(
        base_url,
        'GET',
        {
          'Access-Control-Allow-Origin': '*'
        }
      );
      return response.data['JSON Response'];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  NOAAForecastedData: async (geoId, startDate, endDate) => {
    try {
      let baseUrl =
        TERAPIPE_BASE_URL +
        `/getNOAAForecastedStats?geoid=${geoId}&start_date=${startDate}`;
      if (endDate) {
        baseUrl += `&end_date=${endDate}`;
      }
      const response = await makeRequest(baseUrl, "GET", {
        "Access-Control-Allow-Origin": "*",
      });
      return response.data["JSON Response"];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  GHCNDData: async (geoId, startDate, endDate) => {
    try {
      let base_url =
      TERAPIPE_BASE_URL +
      `/getGHCNDStats?geoid=${geoId}&start_date=${startDate}`;
    if (endDate) {
      base_url += `&end_date=${endDate}`;
    }
      const response = await makeRequest(
        base_url,
        'GET',
        {
          'Access-Control-Allow-Origin': '*'
        }
      );
      return response.data['JSON Response'];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  AUSData: async (geoId, startDate, endDate) => {
    try {
      let base_url =
        TERAPIPE_BASE_URL +
        `/getAUSStats?geoid=${geoId}&start_date=${startDate}`;
      if (endDate) {
        base_url += `&end_date=${endDate}`;
      }
      const response = await makeRequest(base_url, "GET", {
        "Access-Control-Allow-Origin": "*",
      });
      return response.data["JSON Response"];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  AUSForecastedData: async (geoId, startDate, endDate) => {
    try {
      let baseUrl =
        TERAPIPE_BASE_URL +
        `/getAUSForecastedStats?geoid=${geoId}&start_date=${startDate}`;
      if (endDate) {
        baseUrl += `&end_date=${endDate}`;
      }
      const response = await makeRequest(baseUrl, "GET", {
        "Access-Control-Allow-Origin": "*",
      });
      return response.data["JSON Response"];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  SatelliteData: async (geoId, startDate, endDate) => {
    try {
      let baseUrl =
        TERAPIPE_BASE_URL +
        `/getSatelliteStats?geoid=${geoId}&start_date=${startDate}`;
      if (endDate) {
        baseUrl += `&end_date=${endDate}`;
      }
      const response = await makeRequest(baseUrl, "GET", {
        "Access-Control-Allow-Origin": "*",
      });
      return response.data["JSON Response"];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  SatelliteStatsData: async (geoId, startDate, endDate) => {
    try {
      let baseUrl =
        TERAPIPE_BASE_URL +
        `/getSatelliteDataStats?geoid=${geoId}&start_date=${startDate}`;
      if (endDate) {
        baseUrl += `&end_date=${endDate}`;
      }
      const response = await makeRequest(baseUrl, "GET", {
        "Access-Control-Allow-Origin": "*",
      });
      return response.data["JSON Response"];
    } catch (error) {
      throw error?.response?.data;
    }
  },
WaterTrend: async (geoId, startDate, endDate) => {
    try {
      // 1. Format Dates (Reuse a shared helper if possible, but this is fine)
      const formatDate = (dateInput) => {
        if (!dateInput) return null;
        if (typeof dateInput === 'string' && dateInput.includes('-')) return dateInput;
        const d = new Date(dateInput);
        if (isNaN(d.getTime())) return null;
        return d.toISOString().split('T')[0];
      };

      const sDate = formatDate(startDate);
      const eDate = formatDate(endDate);

      // 2. Use makeRequest instead of fetch
      // Ensure your backend accepts JSON in the body. 
      // If makeRequest is a wrapper around axios, 'data' property is usually the body.
      const url = `${TERAPIPE_BASE_URL}/getWaterDemandDailyStats`;
      
      const token = localStorage.getItem("access_token");
      if (!token) throw new Error("No token found");

      // Assuming makeRequest signature is: (url, method, headers, data/body)
      // Check your makeRequest definition. If it's Axios-based, the 4th arg is usually data.
      const response = await makeRequest(url, "POST", {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      }, {
          geoid: geoId,
          start_date: sDate,
          end_date: eDate,
      });

      // Axios returns data in response.data
      return response.data; 

    } catch (error) {
      console.error("WaterWaterDemand Error:", error);
      throw error?.response?.data || error;
    }
},



MonthlyWaterDemand: async (geoId, startDate, endDate) => {
    try {
      // 1. Format Dates (Reuse a shared helper if possible, but this is fine)
      const formatDate = (dateInput) => {
        if (!dateInput) return null;
        if (typeof dateInput === 'string' && dateInput.includes('-')) return dateInput;
        const d = new Date(dateInput);
        if (isNaN(d.getTime())) return null;
        return d.toISOString().split('T')[0];
      };

      const sDate = formatDate(startDate);
      const eDate = formatDate(endDate);

      // 2. Use makeRequest instead of fetch
      // Ensure your backend accepts JSON in the body. 
      // If makeRequest is a wrapper around axios, 'data' property is usually the body.
      const url = `${TERAPIPE_BASE_URL}/getWaterDemandMonthlyStats`;
      
      const token = localStorage.getItem("access_token");
      if (!token) throw new Error("No token found");

      // Assuming makeRequest signature is: (url, method, headers, data/body)
      // Check your makeRequest definition. If it's Axios-based, the 4th arg is usually data.
      const response = await makeRequest(url, "POST", {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      }, {
          geoid: geoId,
          start_date: sDate,
          end_date: eDate,
      });

      // Axios returns data in response.data
      return response.data; 

    } catch (error) {
      console.error("MonthlyWaterDemand Error:", error);
      throw error?.response?.data || error;
    }
},

Vigor: async (geoId, startDate, endDate) => {
  try {
    const baseUrl = `${TERAPIPE_BASE_URL}/vigor_plot_Stats`;
    let token = localStorage.getItem("access_token"); 
    const response = await makeRequest(baseUrl, "POST", {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}` 
    }, {
      geoid: geoId,
      start_date: startDate,
      end_date: endDate,
    });
    // console.log("Vigor Response:", response.data);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
},

downloadVigorCSV: async (geoid) => {
    try {
      // 1. Retrieve the token
      // CHECK THIS: Ensure "token" is the actual key name in your Local Storage
      let token = localStorage.getItem("access_token"); 

      if (!token) {
        alert("You are not logged in (Token is missing).");
        return;
      }

      // 2. Handle cases where token might be a JSON object or stringified
      // Example: If storage contains {"token": "eyJ..."}, we need to parse it.
      try {
        const parsed = JSON.parse(token);
        if (parsed && parsed.token) token = parsed.token;
        else if (parsed && parsed.access_token) token = parsed.access_token;
      } catch (e) {
        // If it fails to parse, it's likely just a plain string, which is good.
      }

      // 3. Perform the fetch
      const response = await fetch(`${TERAPIPE_BASE_URL}/vigor_csv_Stats`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` 
        },
        body: JSON.stringify({ geoid: geoid }) 
      });

      console.log("Download Vigor CSV Response:", response);

      if (!response.ok) {
        // Parse error message safely
        const errData = await response.json().catch(() => ({})); 
        throw new Error(errData.message || `Server returned ${response.status}`);
      }

      // --- File Download Logic ---
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = `annual_vigor_${geoid.substring(0, 8)}.csv`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1];
        }
      }
      
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Download failed:", error);
      alert(`Failed to download CSV: ${error.message}`);
    }
} ,


getPlotGDD: async (geoId) => {
    try {
  
      const url = `${TERAPIPE_BASE_URL}/getgddStats`;
      
      const token = localStorage.getItem("access_token");
      if (!token) throw new Error("No token found");

      const response = await makeRequest(url, "POST", {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      }, {
          geoid: geoId
      });

      // --- FIX: Sanitize and Parse ---
      let result = response.data;

      // 1. Check if it's a string (Worker API often returns stringified JSON)
      if (typeof result === 'string') {
          try {
              // 2. CRITICAL FIX: Replace "NaN" with "null" before parsing
              const sanitizedString = result.replace(/NaN/g, "null");
              result = JSON.parse(sanitizedString);
          } catch (e) {
              console.error("Error parsing GDD JSON:", e);
          }
      }

      return result; 

    } catch (error) {
      console.error("MonthlyWaterDemand Error:", error);
      throw error?.response?.data || error;
    }
},

getPlotChill: async (geoId) => {
    try {
  
      const url = `${TERAPIPE_BASE_URL}/getChillStats`;
      
      const token = localStorage.getItem("access_token");
      if (!token) throw new Error("No token found");

      const response = await makeRequest(url, "POST", {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      }, {
          geoid: geoId
      });

      // --- FIX: Sanitize and Parse ---
      let result = response.data;

      // 1. Check if it's a string (Worker API often returns stringified JSON)
      if (typeof result === 'string') {
          try {
              // 2. CRITICAL FIX: Replace "NaN" with "null" before parsing
              const sanitizedString = result.replace(/NaN/g, "null");
              result = JSON.parse(sanitizedString);
          } catch (e) {
              console.error("Error parsing chill JSON:", e);
          }
      }

      return result; 

    } catch (error) {
      console.error("MonthlyWaterDemand Error:", error);
      throw error?.response?.data || error;
    }
},

// MapService.jsx

getPlotTemperature: async (geoId) => {
    try {
      const url = `${TERAPIPE_BASE_URL}/gettemperatureStats`;
      const token = localStorage.getItem("access_token");
      
      const response = await makeRequest(url, "POST", {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      }, {
          geoid: geoId
      });

      let result = response.data;

      // 1. Check if it's a string (Worker API often returns stringified JSON)
      if (typeof result === 'string') {
          try {
              // 2. CRITICAL FIX: Replace "NaN" with "null" before parsing
              // The regex /NaN/g finds all occurrences of NaN and replaces them
              const sanitizedString = result.replace(/NaN/g, "null");
              
              result = JSON.parse(sanitizedString);
          } catch (e) {
              console.error("Error parsing sanitized JSON:", e);
          }
      }
      
      console.log("Temperature Parsed Data:", result);
      return result; 

    } catch (error) {
      console.error("Temperature Plot Error:", error);
      throw error?.response?.data || error;
    }
},

getPlotPrecipitation: async (geoId) => {
    try {
  
      const url = `${TERAPIPE_BASE_URL}/getprecipitationStats`;
      
      const token = localStorage.getItem("access_token");
      if (!token) throw new Error("No token found");

      const response = await makeRequest(url, "POST", {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      }, {
          geoid: geoId
      });

      // --- FIX: Sanitize and Parse ---
      let result = response.data;

      // 1. Check if it's a string (Worker API often returns stringified JSON)
      if (typeof result === 'string') {
          try {
              // 2. CRITICAL FIX: Replace "NaN" with "null" before parsing
              const sanitizedString = result.replace(/NaN/g, "null");
              result = JSON.parse(sanitizedString);
          } catch (e) {
              console.error("Error parsing precipitation JSON:", e);
          }
      }

      return result; 

    } catch (error) {
      console.error("Precipitation Plot Error:", error);
      throw error?.response?.data || error;
    }
},
getPlotHumidity: async (geoId) => {
    try {
  
      const url = `${TERAPIPE_BASE_URL}/gethumidityStats`;
      
      const token = localStorage.getItem("access_token");
      if (!token) throw new Error("No token found");

      const response = await makeRequest(url, "POST", {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      }, {
          geoid: geoId
      });

      // --- FIX: Sanitize and Parse ---
      let result = response.data;

      // 1. Check if it's a string (Worker API often returns stringified JSON)
      if (typeof result === 'string') {
          try {
              // 2. CRITICAL FIX: Replace "NaN" with "null" before parsing
              const sanitizedString = result.replace(/NaN/g, "null");
              result = JSON.parse(sanitizedString);
          } catch (e) {
              console.error("Error parsing humidity JSON:", e);
          }
      }

      return result; 

    } catch (error) {
      console.error("MonthlyWaterDemand Error:", error);
      throw error?.response?.data || error;
    }
},

getPlotWind: async (geoId) => {
    try {
  
      const url = `${TERAPIPE_BASE_URL}/getWindStats`;
      
      const token = localStorage.getItem("access_token");
      if (!token) throw new Error("No token found");

      const response = await makeRequest(url, "POST", {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      }, {
          geoid: geoId
      });

      // --- FIX: Sanitize and Parse ---
      let result = response.data;

      // 1. Check if it's a string (Worker API often returns stringified JSON)
      if (typeof result === 'string') {
          try {
              // 2. CRITICAL FIX: Replace "NaN" with "null" before parsing
              const sanitizedString = result.replace(/NaN/g, "null");
              result = JSON.parse(sanitizedString);
          } catch (e) {
              console.error("Error parsing wind JSON:", e);
          }
      }

      return result; 

    } catch (error) {
      console.error("MonthlyWaterDemand Error:", error);
      throw error?.response?.data || error;
    }
},

SoilTrend: async (geoId) => {
  try {
    const baseUrl = `${TERAPIPE_BASE_URL}/getSoilPropertiesStats?geoid=${geoId}`;

    const response = await makeRequest(baseUrl, "GET", {
      "Accept": "*/*",
      "User-Agent": "Terapipe Client",
      "secretkey": "dkpnSTZVeWRhWG5NNmdpY2xPM2kzNnJ3cXJkbWpFaQ==",
      "client": "Dev",
    });

    console.log("SoilTrend Response:", response.data);
    return response.data["JSON Response"];
  } catch (error) {
    throw error?.response?.data || error;
  }
} ,



// SoilTrend: async (geoId) => {
//   try {
//     const baseUrl = `${TERAPIPE_BASE_URL}/getSoilPropertiesStats?geoid=${geoId}`;

//     const response = await makeRequest(baseUrl, "GET", {
//       "Accept": "*/*",
//       "User-Agent": "Terapipe Client",
//       "secretkey": "dkpnSTZVeWRhWG5NNmdpY2xPM2kzNnJ3cXJkbWpFaQ==",
//       "client": "Dev",
//     });

//     console.log("SoilTrend Response:", response.data);
//     return response.data["JSON Response"];
//   } catch (error) {
//     throw error?.response?.data || error;
//   }
// } ,

// WeatherEtcData: async (geoId, startDate, endDate) => {
 
//     try {
//       let baseUrl =
//         TERAPIPE_BASE_URL +
//         `/getWeatherEtcStats?geoid=${geoId}&start_date=${startDate}`;
//       if (endDate) {
//         baseUrl += `&end_date=${endDate}`;
//       }
//       const response = await makeRequest(baseUrl, "GET", {
//         "Access-Control-Allow-Origin": "*",
//       });
//       console.log("WeatherEtcData Response:", response.data);
//       return response.data["JSON Response"];
//     } catch (error) {
//       throw error?.response?.data;
//     }
//   },

WeatherEtcData: async (geoId, startDate, endDate) => {
  try {
    let base_url =
      TERAPIPE_BASE_URL +
      `/getWeatherEtcStats?geoid=${geoId}&start_date=${startDate}`;
    if (endDate) {
      base_url += `&end_date=${endDate}`;
    }

    const token = Cookies.get('access_token');

    const response = await fetch(base_url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Authorization": token ? `Bearer ${token}` : "", 
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API Error: ${response.status} - ${errorText}`);
    }

    const textData = await response.text();
    const sanitizedText = textData.replace(/:\s*NaN/g, ": null");
    const parsedData = JSON.parse(sanitizedText);
    return parsedData["JSON Response"];

  } catch (error) {
    console.error("WeatherEtcStats Data Parse Error:", error);
    throw error;
  }
  },


CropData: async (geoId, startYear, endYear) => {
    try {
      let baseUrl =
        TERAPIPE_BASE_URL +
        `/getCropDataStats?geoid=${geoId}&start_year=${startYear}&end_year=${endYear}`;
 
      const response = await makeRequest(baseUrl, "GET", {
        "Access-Control-Allow-Origin": "*",
      });
      return response.data["JSON Response"];
    } catch (error) {
      throw error?.response?.data;
    }
  },

CIMISData: async (geoId, startDate, endDate) => {
    try {
      let baseUrl =
        TERAPIPE_BASE_URL +
        `/getCIMISStats?geoid=${geoId}&start_date=${startDate}`;
      if (endDate) {
        baseUrl += `&end_date=${endDate}`;
      }
      const response = await makeRequest(baseUrl, "GET", {
        "Access-Control-Allow-Origin": "*",
      });
      return response.data["JSON Response"];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  JRCData: async (geoId) => {
    try {
      let baseUrl =
        TERAPIPE_BASE_URL +
        `/getJRCStats?geoid=${geoId}`;
      const response = await makeRequest(baseUrl, "GET", {
        "Access-Control-Allow-Origin": "*",
      });
      return response.data["JSON Response"];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  ETOData: async (geoId, startDate, endDate) => {
    try {
      let baseUrl =
        TERAPIPE_BASE_URL +
        `/getETOStats?geoid=${geoId}&start_date=${startDate}`;
      if (endDate) {
        baseUrl += `&end_date=${endDate}`;
      }
      const response = await makeRequest(baseUrl, "GET", {
        "Access-Control-Allow-Origin": "*",
      });
      return response.data["JSON Response"];
    } catch (error) {
      throw error?.response?.data;
    }
  },
  ETAData: async (geoId, startDate, endDate) => {
    try {
      let base_url =
        TERAPIPE_BASE_URL +
        `/getETAStats?geoid=${geoId}&start_date=${startDate}`;
      if (endDate) {
        base_url += `&end_date=${endDate}`;
      }
      const response = await makeRequest(base_url, "GET", {
        "Access-Control-Allow-Origin": "*",
      });
      return response.data["JSON Response"];
    } catch (error) {
      throw error?.response?.data;
    }
  },

WEEKETAData: async (geoId, startDate, endDate) => {
  try {
    const userId = localStorage.getItem('user_id'); 
    if (!userId) throw new Error("User ID not found. Are you logged in?");
    let base_url = `${TERAPIPE_BASE_URL}/getWeeklyETAStats?user_id=${userId}&geoid=${geoId}&product_id=eta`;
    if (startDate) base_url += `&start_date=${startDate}`;
    if (endDate) base_url += `&end_date=${endDate}`;

    const response = await makeRequest(base_url, "GET", {
      "Access-Control-Allow-Origin": "*", // This may not be necessary client-side
    });

    return response.data["JSON Response"];
  } catch (error) {
    console.error("WEEKETAData error:", error);
    throw error?.response?.data || error.message;
  }
},



DAILYETAData: async (geoId, startDate, endDate) => {
  try {
    const userId = localStorage.getItem('user_id'); 
    if (!userId) throw new Error("User ID not found. Are you logged in?");

    // Construct the query params
    const params = new URLSearchParams({
      user_id: userId,
      geoid: geoId,
      product_id: 'eta' ,
      subscription_type :'daily'
    });

    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);

    const base_url = `${TERAPIPE_BASE_URL}/getDailyETAEmailStats?${params.toString()}`;
    console.log("Fetching ETA Stats:", base_url);

    const response = await makeRequest(base_url, "GET");

    console.log("ETA Response:", response?.data?.["JSON Response"]);
    return response.data?.["JSON Response"];
  } catch (error) {
    console.error("DAILYETAData error:", error);
    throw error?.response?.data || error.message;
  }
},

// DAILYETAData: async (geoId, startDate, endDate) => {
//   try {
//     const userId = localStorage.getItem('user_id'); 
//     if (!userId) throw new Error("User ID not found. Are you logged in?");
//     let base_url = `${TERAPIPE_BASE_URL}/getDailyETAStats?geoid=${geoId}`;
//     if (startDate) base_url += `&start_date=${startDate}`;
//     if (endDate) base_url += `&end_date=${endDate}`;

//     const response = await makeRequest(base_url, "GET", {
//       // "Access-Control-Allow-Origin": "*", // This may not be necessary client-side
//     });
//     console.log(response.data["JSON Response"])
//     return response.data["JSON Response"];
//   } catch (error) {
//     console.error("Daily Data error:", error);
//     throw error?.response?.data || error.message;
//   }
// },

SubscribeStatus: async (geoId) => {
  try {
    const token = localStorage.getItem('access_token');  // make sure this is saved during login
    if (!token) throw new Error("Access token not found.");

    const base_url = `${TERAPIPE_BASE_URL}/getSubStatus?geoid=${geoId}`;

    const response = await makeRequest(base_url, "GET", {
      "Authorization": `Bearer ${token}`
    });

    // const response = await makeRequest(TERAPIPE_BASE_URL + `/getSubStatus?geoid=${geoId}`, 'GET', {
    //     'Access-Control-Allow-Origin': '*'
    //   });
    console.log(response.data["JSON Response"])
    return response.data["JSON Response"];
  } catch (error) {
    console.error("subscription error:", error);
    throw error?.response?.data || error.message;
  }
}
,



SubscribeToETA: async (geoId, subscriptionType = "weekly") => {
  try {
    const userId = localStorage.getItem("user_id");
    const fieldName = localStorage.getItem("field_name");

    if (!userId || !fieldName) {
      throw new Error("User ID or field name not found in local storage.");
    }

    const payload = {
      user_id: userId,
      geoid: geoId,
      product_id: "eta",
      field_name: fieldName,
      subscription_type: subscriptionType,
    };

    console.log("Request URL:", TERAPIPE_BASE_URL);
    console.log("Payload:", payload);
    const response = await makeRequest(
      `${TERAPIPE_BASE_URL}/getSubscribe`,
      "POST",
      { "Content-Type": "application/json" },
      payload
    );

    return response.data;
  } catch (error) {
    console.error("SubscribeToETA error:", error);
    throw error?.response?.data || error.message;
  }
},



UnsubscribeFromETA: async (geoId, subscriptionType) => {
    try {
      const userId = localStorage.getItem('user_id'); 
      const field_name = localStorage.getItem('field_name'); 
      const authToken = localStorage.getItem('access_token');

      if (!userId || !field_name || !authToken) {
        throw new Error(
          `Missing required localStorage items: ${!userId ? 'user_id, ' : ''}${
            !field_name ? 'field_name, ' : ''
          }${!authToken ? 'access_token' : ''}`
        );
      }

      const base_url = `${TERAPIPE_BASE_URL}/getUnsubscribe`;
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      };

      const body = JSON.stringify({
        user_id: userId,
        geoid: geoId,
        field_name: field_name,
        product_id: 'eta',
        subscription_type: subscriptionType
      });

      const response = await makeRequest(base_url, "POST", headers, body);
      return response.data["JSON Response"] || response.data;
    } catch (error) {
      throw error?.response?.data?.error || error.message;
    }
  },


  NDVIDatesEarlier: async (geoId, minDate) => {
    try {
      const response = await makeRequest(
        TERAPIPE_BASE_URL + `/loadNDVIDatesEarlier?geoid=${geoId}&min_date=${minDate}`,
        'GET',
        {
          'Access-Control-Allow-Origin': '*'
        }
      );
      return response.data['JSON Response'];
    } catch (error) {
      throw error?.response?.data;
    }
  },

    NDVIDates: async (geoId) => {
    try {
      const response = await makeRequest(TERAPIPE_BASE_URL + `/getNDVIDatesForGeoidMonth?geoid=${geoId}`, 'GET', {
        'Access-Control-Allow-Origin': '*'
      });
      return response.data['JSON Response'];
    } catch (error) {
      throw error?.response?.data;
    }
  },

  NDVIImg: async (geoId, imgDate, level) => {
    try {
      const response = await makeRequest(TERAPIPE_BASE_URL + `/getNDVIImg?geoid=${geoId}&dt=${imgDate}&level=${level}`, 'GET', {
        'Access-Control-Allow-Origin': '*'
      });
      return response.data;
    } catch (error) {
      throw error?.response?.data;
    }
  },
  getFieldWithPoint: async (lat, lng, boundary_type, s2_index, domain) => {
    try {
      const response = await makeRequest(
        TERAPIPE_BASE_URL + `/fetch-fields-for-a-point`,
        'POST',
        {
          'Access-Control-Allow-Origin': '*'
        },
        { latitude: lat, longitude: lng, s2_index, domain, boundary_type }
      );
      const data = response.data['Fetched fields'].map((e) => Object.values(e)).map((e) => e[0]['Geo JSON']);
      return { data, json: response.data };
    } catch (error) {
      throw error?.response?.data;
    }
  },
  getFieldWithRectangle: async (lats, lngs) => {
    try {
      const response = await makeRequest(
        TERAPIPE_BASE_URL + `/fetch-bounding-box-fields`,
        'POST',
        {
          'Access-Control-Allow-Origin': '*'
        },
        { latitudes: lats, longitudes: lngs }
      );
      const data = response.data['message'].map((e) => Object.values(e)).map((e) => e[0]['Geo JSON']);
      return { data, json: response.data };
    } catch (error) {
      throw error?.response?.data;
    }
  },
  getOverlappingFields: async (wktData, resolution_level, threshold, domain, boundary_type, s2_index) => {
    try {
      const response = await makeRequest(
        TERAPIPE_BASE_URL + `/fetch-overlapping-fields`,
        'POST',
        {
          'Access-Control-Allow-Origin': '*'
        },
        {
          wkt: wktData,
          resolution_level,
          threshold,
          domain,
          boundary_type,
          s2_index
        }
      );
      const data = response.data['Matched Fields'].map((e) => Object.values(e)).map((e) => e[0]['Geo JSON']);
      return { data, json: response.data };
    } catch (error) {
      throw error?.response?.data;
    }
  },
  registerField: async (wktData, resolution_level, threshold, s2_index) => {
    try {
      const response = await makeRequest(
        TERAPIPE_BASE_URL + `/register-field-boundary`,
        'POST',
        {
          'Access-Control-Allow-Origin': '*'
        },
        { wkt: wktData, resolution_level, threshold, s2_index }
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data;
    }
  },
  getDomains: async () => {
    try {
      const response = await makeRequest(TERAPIPE_BASE_URL + `/domains`, 'GET', {
        'Access-Control-Allow-Origin': '*'
      });
      return response.data;
    } catch (error) {
      throw error?.response?.data;
    }
  },
  getPercentageOverlapFields: async (geojson1, geojson2) => {
    try {
      const response = await makeRequest(
        TERAPIPE_BASE_URL + `/get-percentage-overlap-two-fields`,
        'POST',
        {
          'Access-Control-Allow-Origin': '*'
        },
        {
          geo_id_field_1: geojson1,
          geo_id_field_2: geojson2
        }
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data;
    }
  },
  getApplications: async () => {
    try {
      const response = await makeRequest(TERAPIPE_BASE_URL + `/api/applications`, 'GET', {
        'Access-Control-Allow-Origin': '*'
      });
      return response.data;
    } catch (error) {
      throw error?.response?.data;
    }
  },
  getTileProgress: async (tileNumber) => {
    try {
        const url = `${TERAPIPE_BASE_URL}/tile_historical_progress?tile_number=${tileNumber}`;
        const token = localStorage.getItem("access_token");
        
        if (!token) throw new Error("No token found");

        const response = await makeRequest(url, "GET", {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        });

        return response.data;
    } catch (error) {
        console.log(error)
        throw error?.response?.data || error;
    }
  },
  getTileProgressAll: async () => {
    try {
        const url = `${TERAPIPE_BASE_URL}/get_historical_tiles_all`;
        const token = localStorage.getItem("access_token");
        
        if (!token) throw new Error("No token found");

        const response = await makeRequest(url, "GET", {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        });

        return response.data;
    } catch (error) {
        console.log(error)
        throw error?.response?.data || error;
    }
  },
  submitLeadDetails: async (payload) => {
    try {
        const url = `${TERAPIPE_BASE_URL}/submit-lead-details`;
        
        const response = await makeRequest(url, "POST", {
            "Content-Type": "application/json"
        }, payload);

        return response.data;
    } catch (error) {
        console.log("Lead submission error:", error);
        throw error?.response?.data || error;
    }
  },
  ETturfData: async (geoId, startDate, endDate) => {
    try {
      let baseUrl =
        TERAPIPE_BASE_URL +
        `/getETturf?geoid=${geoId}&start_date=${startDate}`;
      if (endDate) {
        baseUrl += `&end_date=${endDate}`;
      }
      const response = await makeRequest(baseUrl, "GET", {
        "Access-Control-Allow-Origin": "*",
      });
      return response.data["JSON Response"]; 
    } catch (error) {
      throw error?.response?.data;
    }
  },
  ETturfDaily: async (geoId, startDate, endDate) => {
    try {
      const formatDate = (dateInput) => {
        if (!dateInput) return null;
        if (typeof dateInput === 'string' && dateInput.includes('-')) return dateInput;
        const d = new Date(dateInput);
        if (isNaN(d.getTime())) return null;
        return d.toISOString().split('T')[0];
      };

      const sDate = formatDate(startDate);
      const eDate = formatDate(endDate);

      const url = `${TERAPIPE_BASE_URL}/getWaterDemandTurfDailyStats`;
      
      const token = localStorage.getItem("access_token");
      if (!token) throw new Error("No token found");

      const response = await makeRequest(url, "POST", {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      }, {
          geoid: geoId,
          start_date: sDate,
          end_date: eDate,
      });

      return response.data; 

    } catch (error) {
      console.error("ETturfDaily Error:", error);
      throw error?.response?.data || error;
    }
  },

  ETturfMonthly: async (geoId, startDate, endDate) => {
    try {
      const formatDate = (dateInput) => {
        if (!dateInput) return null;
        if (typeof dateInput === 'string' && dateInput.includes('-')) return dateInput;
        const d = new Date(dateInput);
        if (isNaN(d.getTime())) return null;
        return d.toISOString().split('T')[0];
      };

      const sDate = formatDate(startDate);
      const eDate = formatDate(endDate);

      const url = `${TERAPIPE_BASE_URL}/getWaterDemandTurfMonthlyStats`;
      
      const token = localStorage.getItem("access_token");
      if (!token) throw new Error("No token found");

      const response = await makeRequest(url, "POST", {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      }, {
          geoid: geoId,
          start_date: sDate,
          end_date: eDate,
      });

      return response.data; 

    } catch (error) {
      console.error("ETturfMonthly Error:", error);
      throw error?.response?.data || error;
    }
  },
  WeatherNasa: async (geoId, startDate, endDate) => {
    try {
      const formatDate = (dateInput) => {
        if (!dateInput) return null;
        if (typeof dateInput === 'string' && dateInput.includes('-')) return dateInput;
        const d = new Date(dateInput);
        if (isNaN(d.getTime())) return null;
        return d.toISOString().split('T')[0];
      };

      const sDate = formatDate(startDate);
      const eDate = formatDate(endDate);

      const queryParams = new URLSearchParams();
      if (geoId) queryParams.append('geoid', geoId);
      if (sDate) queryParams.append('start_date', sDate);
      if (eDate) queryParams.append('end_date', eDate);

      const url = `${TERAPIPE_BASE_URL}/getWeather?${queryParams.toString()}`;
      
      const token = localStorage.getItem("access_token");
      if (!token) throw new Error("No token found");

      const response = await makeRequest(url, "GET", {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      }, null);

      return response.data; 

    } catch (error) {
      console.error("WeatherNasa API Error:", error);
      throw error?.response?.data || error;
    }
  }
};

export default MapService;
